import { supabase } from '../supabase.js';

let inited = false;

export function initLogin() {
  if (inited) return;
  inited = true;

  const form       = document.getElementById('login-form');
  const email      = document.getElementById('login-email');
  const password   = document.getElementById('login-password');
  const submit     = document.getElementById('login-submit');
  const googleBtn  = document.getElementById('login-google');
  const msg        = document.getElementById('login-msg');

  function showError(text) {
    msg.textContent = text;
    msg.className = 'login-msg error';
  }
  function clearError() {
    msg.textContent = '';
    msg.className = 'login-msg';
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearError();
    submit.disabled = true;
    submit.textContent = 'Signing in…';

    const { error } = await supabase.auth.signInWithPassword({
      email:    email.value.trim(),
      password: password.value,
    });

    submit.disabled = false;
    submit.textContent = 'Sign in';
    if (error) showError(error.message);
  });

  document.getElementById('forgot-pw-link').addEventListener('click', async (e) => {
    e.preventDefault();
    const addr = email.value.trim();
    if (!addr) {
      showError('Enter your email address above first.');
      return;
    }
    clearError();
    const link = e.target;
    link.textContent = 'Sending…';
    const { error: resetErr } = await supabase.auth.resetPasswordForEmail(addr, {
      redirectTo: window.location.origin,
    });
    link.textContent = 'Forgot password?';
    if (resetErr) {
      showError(resetErr.message);
    } else {
      msg.textContent = `Reset link sent to ${addr} — check your inbox.`;
      msg.className = 'login-msg';
    }
  });

  googleBtn.addEventListener('click', async () => {
    clearError();
    googleBtn.disabled = true;
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options:  { redirectTo: window.location.origin },
    });
    googleBtn.disabled = false;
    if (error) showError(error.message);
    // On success, browser navigates to Google then back to redirectTo,
    // and onAuthStateChange in main.js handles the rest.
  });
}
